import { ConnectionMode } from '../types';
import type { Connection, HandleType } from '../types';

/** Identifies one handle of one node. */
export type HandleRef = { nodeId: string; handleId: string | null; type: HandleType };

/** Whether a connection started at `from` may end at `to` (v11 rules). */
export const canConnect = (from: HandleRef, to: HandleRef, connectionMode: ConnectionMode): boolean => {
  if (connectionMode === ConnectionMode.Strict) return from.type !== to.type;
  return from.nodeId !== to.nodeId || from.handleId !== to.handleId;
};

/** The connection reported to `onConnect`; dragging from a target swaps the ends. Key order matters (socket payload). */
export const toConnection = (from: HandleRef, to: HandleRef): Connection => {
  const [source, target] = from.type === 'target' ? [to, from] : [from, to];
  return { source: source.nodeId, sourceHandle: source.handleId, target: target.nodeId, targetHandle: target.handleId };
};
